import { BUILD_ID } from 'config/envVariable';

const fontLoader = () => {
    // 載入 Icon Font 字型
    const iconLink = document.createElement('link');
    const hash = BUILD_ID ? `?${BUILD_ID}` : '';
    iconLink.href = `https://utility.fevercdn.com/icon-font/fever-icon-font.css.gz${hash}`;
    iconLink.rel = 'stylesheet preconnect';
    iconLink.crossOrigin = 'anonymous';
    document.head.appendChild(iconLink);

    // 載入 google 字型
    const fontLink = document.createElement('link');
    fontLink.href = 'https://utility.fevercdn.com/font/style/fonts.css';
    fontLink.rel = 'stylesheet preconnect';
    fontLink.crossOrigin = 'anonymous';

    document.head.appendChild(fontLink);
};

export default fontLoader;
